import constants from 'constants/index'

const legalFrameworkLabel = (id) => {
  return (id && constants.consent.LEGAL_BASE_LABEL_CONSENT[id]) || 'Indefinido'
}

export default legalFrameworkLabel
